// Stall Participant routes
export const stallParticipantProfile = 'stall-participant/profile'
export const stallParticipantProfileList = stallParticipantProfile + '/list'
export const stallParticipantProfileStore = stallParticipantProfile + '/store'
export const stallParticipantProfileUpdate = stallParticipantProfile + '/update'
export const stallParticipantProfileShow = stallParticipantProfile + '/profile-info'

// Apply FOr Stall routes
export const stallProfileShow = 'stall-participant/apply-stall/profile-info'
export const applyStallStore = 'stall-participant/apply-stall/store'
export const applyStallList = 'stall-participant/apply-stall/list'
export const applyStallShow = 'stall-participant/apply-stall/show'
export const applyStallUpdate = 'stall-participant/apply-stall/update'
export const stallInfoData = 'stall-participant/apply-stall/stall-info'

// Stall Participant E Certificate routes
export const stallParticipantCertificate = 'stall-participant/certificate'
export const stallParticipantCertificateData = stallParticipantCertificate + '/data'

// Stall Participant Every Summary Report
export const stallPanelEventSummaryReport = 'stall-participant/reports/event-summary'
export const reportHeadingList = '/configuration/report-heading/detail'
export const stallParticipantCertificateDataList = stallParticipantCertificate + '/datalist'
export const reportHeadingListNew = 'configuration/report-heading/listnew'

// E Learning routes
export const TraineeProfile = 'training-e-learning/profile/'
export const TraineeProfileShow = TraineeProfile + 'profile-info'
export const traineeProfileStore = TraineeProfile + 'store'

export const TraineeProfileFaq = TraineeProfile + 'faq'
export const CircularList = TraineeProfile + 'circular-info'
export const ScheduleList = TraineeProfile + 'schedule-info'
export const certificateList = TraineeProfile + 'certificate-list'
export const applicationApply = 'applicationManagement/application/apply'
export const UserComplainListApi = 'complain/user-complain'
export const UserComplainStoreApi = 'complain/store'

export const UserDocReqListApi = 'doc-request/user-doc'
export const UserEnrollTrainingApi = 'doc-request/training-list'
export const UserDocReqApi = 'doc-request/store'

// Trainer Evaluation
export const trainerListApi = 'trainer-trainee-info/trainer-evaluation/trainer-list'
export const traineeDataApi = 'trainer-trainee-info/trainer-evaluation/trainee-list'
export const trainerDataApi = 'trainer-trainee-info/trainer-evaluation/trainer-list'
export const trainerEvaluationListApi = 'trainer-trainee-info/trainer-evaluation/list'
export const trainerEvaluationStoreApi = 'trainer-trainee-info/trainer-evaluation/store'
export const circularDataApi = 'training-plan-management/training-routine/circular-data'
